import * as actionTypes from './actionTypes';
import { serviceHeadBand } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { fetchValidateAccess } from '@app/src/common/session';

const fetchHeadBandRequest = () => ({
  type: actionTypes.FETCH_HEADBAND_REQUEST
});

const fetchHeadBandSuccess = (data) => ({
  type: actionTypes.FETCH_HEADBAND_SUCCESS,
  data
});

const fetchHeadBandFailure = () => ({
  type: actionTypes.FETCH_HEADBAND_FAILURE
});

export const showHeadBand = (show: boolean) => ({
  type: actionTypes.SHOW_HEADBAND,
  show
});

export const hideHeadBand = () => ({
  type: actionTypes.HIDE_HEADBAND
});

export const fetchHeadBand = (): Function => {
  return async dispatch => {
    dispatch(fetchHeadBandRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await serviceHeadBand.get();
      dispatch(fetchHeadBandSuccess(data[0]));
    } catch (e) {
      dispatch(fetchHeadBandFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
}